
import { defineComponent } from "vue";
import NumberInput from "@/components/wmc/NumberInput.vue";
import { debounce } from "lodash";

export default defineComponent({
  name: "NumberButtonInput",
  data() {
    return {
      debouncedQuantidadeChange: null as ((quantidade: number) => void) | null
    };
  },
  components: {
    NumberInput,
  },
  props: {
    smallSize: {
      type: Boolean,
      default: false,
    },
    isCard: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: undefined,
    },
  },
  created() {
    this.debouncedQuantidadeChange = debounce(
      (quantidade: number) => this.onQuantidadePageChange(quantidade),
      500
    );
  },
  methods: {
    onQuantidadePageChange(quantidade: number) {
      if (this.max !== undefined && quantidade > this.max) {
        quantidade = this.max;
      }
      this.$emit("input", quantidade);
    },
  },
});
